module.exports = __webpack_public_path__ + "static/media/Facebook.95d2e22c.svg";